import { ca } from '@cian/analytics';

import { TTabsType } from '../../types/newbuildingTiledCarousel';

export const trackPhoneOpen = (label: string) => {
  ca('eventSite', {
    category: 'Phones',
    action: 'Open_card_fullscreen_gallery',
    label,
    useLastProducts: true,
  });
};

export const trackFullscreenOpen = () => {
  ca('eventSite', {
    category: 'card',
    action: 'click',
    label: 'fullscreen_gallery',
    useLastProducts: true,
  });
};

export const trackFullscreenScrollDepth = (scrollDepth: number) => {
  ca('eventSite', {
    category: 'card',
    action: 'scroll',
    label: 'fullscreen_gallery',
    useLastProducts: true,
    page: {
      pageType: 'Card',
      siteType: 'desktop',
      pageextra: {
        scroll_depth: scrollDepth,
      },
    },
  });
};

export const trackFullscreenTabClick = (tab: TTabsType) => {
  ca('eventSite', {
    category: 'card',
    action: 'click',
    label: 'fullscreen_gallery_tab',
    useLastProducts: true,
    page: {
      pageType: 'Card',
      siteType: 'desktop',
      pageextra: {
        tab,
      },
    },
  });
};
